import React from 'react';
import { authPages, errorPages } from '../menu';
import Footer from '../layout/Footer/Footer';

const footers = [
	{ path: authPages.login.path, element: null, exact: true },
	{ path: authPages.forgotPassword.path, element: null, exact: true },
	{ path: errorPages.pageNotFound.path, element: null, exact: true },
	{ path: '*', element: <Footer /> },
];

export default footers;
